import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Platform} from 'react-native';

export const Wrapper = styled.View`
  flex-direction: row;
  align-items: center;
`;

interface TrackProps {
  height: number;
}

export const Track = styled.View<TrackProps>`
  flex: 1;
  height: ${({height}) => RFValue(height)}px;
  background-color: ${({theme}) => theme.colors.background_secondary};
  border-radius: ${({height}) => RFValue(height / 2)}px;
  overflow: hidden;
  ${Platform.OS === 'ios'
    ? `
    shadow-color: #000;
    shadow-offset: 0px 6px;
    shadow-opacity: 0.25;
    shadow-radius: 12px;
  `
    : `
    elevation: 10;
  `}
`;

export const GhostFill = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({theme}) => theme.colors.background_black_2};
`;

interface BadgeProps {
  size: number;
  backgroundColor?: string;
  borderColor?: string;
}

export const Badge = styled.View<BadgeProps>`
  width: ${({size}) => RFValue(size)}px;
  height: ${({size}) => RFValue(size)}px;
  border-radius: ${({size}) => RFValue(size / 2)}px;
  margin-left: ${({size}) => RFValue(-size * 0.48)}px;
  background-color: ${({backgroundColor, theme}) =>
    backgroundColor ?? theme.colors.shape};
  align-items: center;
  justify-content: center;
  border-width: 3px;
  border-color: ${({borderColor, theme}) => borderColor ?? theme.colors.gold};
  ${({theme, borderColor}) =>
    Platform.OS === 'ios'
      ? `
    shadow-color: ${borderColor ?? theme.colors.gold};
    shadow-offset: 0px 0px;
    shadow-opacity: 0.5;
    shadow-radius: 12px;
  `
      : `
    elevation: 12;
  `}
`;
